module.exports = __webpack_public_path__ + "b74ef1680f98ac3c0f7cfbc5b054ecb8.jpg";